import axios from 'axios';

const api = axios.create({ baseURL: '' });

// Injeta token em todas as requisições
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Redireciona para login se token expirar
api.interceptors.response.use(
    res => res,
    err => {
        if (err.response?.status === 401) {
            console.warn(
                '[Sigatron] Sessão encerrada por um 401 — se isso não era esperado, envie este print ao suporte:',
                {
                    quando: new Date().toISOString(),
                    url: err.config?.url,
                    metodo: err.config?.method,
                    motivoServidor: err.response?.data?.erro,
                    tinhaTokenEnviado: !!err.config?.headers?.Authorization,
                }
            );
            localStorage.removeItem('token');
            localStorage.removeItem('usuario');
            window.location.href = '/';
        }
        return Promise.reject(err);
    }
);

export const login = (email, senha, manterConectado) => api.post('/api/auth/login', { email, senha, manterConectado });
export const getVeiculos = () => api.get('/api/veiculos');
export const getHistorico = (id, inicio, fim) => api.get(`/api/historico/${id}`, { params: { inicio, fim } });
export const criarVeiculo = (dados) => api.post('/api/veiculos', dados);
export const atualizarVeiculo = (id, dados) => api.put(`/api/veiculos/${id}`, dados);
export const deletarVeiculo = (id) => api.delete(`/api/veiculos/${id}`);
export const getEquipamentos = () => api.get('/api/equipamentos');
export const criarEquipamento = (dados) => api.post('/api/equipamentos', dados);
export const atualizarEquipamento = (id, dados) => api.put(`/api/equipamentos/${id}`, dados);
export const deletarEquipamento = (id) => api.delete(`/api/equipamentos/${id}`);
export const getLogsConexao = () => api.get('/api/logs/conexao');
export const limparLogsConexao = () => api.delete('/api/logs/conexao');
export const getStatus = () => api.get('/api/status');
export const getAuditoria = (filtros) => api.get('/api/auditoria', { params: filtros });
export const getNotificacoes = (pendentes) => api.get('/api/notificacoes', { params: pendentes ? { pendentes: '1' } : {} });
export const atenderNotificacao = (id, observacao) => api.put(`/api/notificacoes/${id}`, { observacao });
export const getConfiguracoes = () => api.get('/api/configuracoes');
export const salvarConfiguracoes = (dados) => api.put('/api/configuracoes', dados);
export const getUsuarios = () => api.get('/api/auth/usuarios');
export const criarUsuario = (dados) => api.post('/api/auth/usuarios', dados);
export const atualizarUsuario = (id, dados) => api.put(`/api/auth/usuarios/${id}`, dados);
export const deletarUsuario = (id) => api.delete(`/api/auth/usuarios/${id}`);
export const encerrarSessoes = (id) => api.post(`/api/auth/usuarios/${id}/encerrar-sessoes`);
